// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:1200px){.sc[data-v-461db21a]{flex-direction:column;align-items:normal!important}.sc>*[data-v-461db21a]{max-width:none}}.parameters[data-v-461db21a]{display:grid;grid-template-columns:1fr auto;grid-gap:15px}", ""]);
// Exports
module.exports = exports;
